export default "__VITE_ASSET__DfZxisSn__"